<!-- <app-header #header></app-header>
<app-breadcrumb></app-breadcrumb> -->
<div class="inprogress">
  <img src="../../../assets/images/EarlyPreview.png" height='35px' style="margin-left:'40px'" />

</div>
<div class="wrapper">
  <div class="row mat-z8">
    <mat-tab-group #matTab [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
      <mat-tab label="Skill Index">
        <ng-container *ngIf="selectedTabIndex === 0">
          <div class="first-row w-100">
            <app-skill-index
              [subCompetencyChartData]="subCompetencyChartData"
              [trainingChartData]="trainingChartData"
              [topTrainings]="topTrainings"
              [serviceAreaList]="serviceAreaList"
              (trainingEmitter)="handleTabSwitch()"
            ></app-skill-index>
          </div>
        </ng-container>
      </mat-tab>

      <mat-tab label="Trainings">
        <ng-container *ngIf="selectedTabIndex === 1">
          <div class="first-row w-100">
            <div class="col-2">
              <p id="listoftrainings">Assigned Trainings</p>
            </div>
            <div class="search-text col-6">
              <div class="icon">
                <span class="material-symbols-outlined">
                  search
                </span>
              </div>
              <div class="w-75">
                <input
                  type="search"
                  class="search"
                  id="search-text"
                  aria-describedby="search-text"
                  [(ngModel)]="searchText"
                  [placeholder]="plpaceholderText"
                  (keyup)="searchTrainings()"
                >
              </div>
            </div>
            <!-- <div class="col-3 addtools">
              <button class="create-training btn custom_btn primary_btn_base col"
                (click)="createTraining(trainingTypeName, trainingTypeId)">
                <i class="fa fa-plus-circle  "></i>
                Create Training
              </button>

            </div> -->
            <div class="export-trainings">
              <button mat-flat-button class="top-buttons" (click)="exportTrainingData()">
                <img class="export_icon" src="../../../assets/images/download_ico_white.svg" alt="">
                Export
              </button>
            </div>
          </div>

          <div class="total w-100 topMarigin" style="margin-bottom: 40px;">
            <table  mat-table [dataSource]="dataSource" matSort class="SkillTable"> 
              <!--  Columns -->
              
              <ng-container matColumnDef="statusIcon">
                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td mat-cell *matCellDef="let row">
                  <div
                    [ngbTooltip]="comments"
                    tooltipClass="custom_tooltip"
                    placement="top-start"
                    triggers="manual"
                    #comments1="ngbTooltip"
                    (mouseleave)="comments1.close()"
                    (mouseover)="comments1.open()"
                  >
                    <span
                      *ngIf="row.icon"
                      class="material-symbols-outlined"
                      style="cursor: default;"
                      [ngStyle]="{ 'color': row.color }"
                    >
                      {{ row.icon }}
                    </span>
                  </div>
                  <ng-template #comments class="custom_tooltip">{{row.tooltip}}</ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="competencyName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="alignment">Competency</th>
                <td mat-cell *matCellDef="let row" class=""> {{row.competency}} </td>
              </ng-container>

              <ng-container matColumnDef="trainingName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Name</th>
                <td mat-cell *matCellDef="let row"> {{row.sessionName}} </td>
              </ng-container>

              <ng-container matColumnDef="trainingMode" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Type</th>
                <td mat-cell *matCellDef="let row">{{row.sessionType}} </td>
              </ng-container>

              <ng-container matColumnDef="locationName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
                <td mat-cell *matCellDef="let row"> {{row.location}} </td>
              </ng-container>

              <ng-container matColumnDef="trainerName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Trainer Name </th>
                <td mat-cell *matCellDef="let row"> {{row.trainerName}} </td>
              </ng-container>

              <ng-container matColumnDef="mentorNames">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Mentors </th>
                <td mat-cell *matCellDef="let row"> {{row.mentorNames ? row.mentorNames : 'Not Assigned'}} </td>
              </ng-container>

              <ng-container matColumnDef="startDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Start Date </th>
                <td mat-cell *matCellDef="let row">{{row.startDate | date:'mediumDate'}} </td>
              </ng-container>

              <ng-container matColumnDef="endDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-heade> End Date </th>
                <td mat-cell *matCellDef="let row">{{row.endDate | date:'mediumDate'}} </td>
              </ng-container>

              <!-- <ng-container matColumnDef="plannedResourcesCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Resources Planned </th>
                <td mat-cell *matCellDef="let row">{{row.resourcesPlanned}} </td>
              </ng-container> -->

              <ng-container matColumnDef="prerequisiteTools">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tools Required </th>
                <td mat-cell *matCellDef="let row"> {{row.toolsRequired}} </td>
              </ng-container>

              <!-- <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status </th>
                <td mat-cell *matCellDef="let row">
                  <span [ngStyle]="{ 'background-color': row.color+'1A','color':row.color }">
                    {{row.trainingStatusDescription}}
                  </span>
                </td>
              </ng-container> -->

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status </th>
                <td mat-cell *matCellDef="let row">
                  <ng-container *ngFor="let status of row.trainingStatusDescription.split(', ')">
                    <span>
                      {{ status.split(':')[0] }}: 
                      <span [ngStyle]="{ 'color': getStatusColor(status) }">
                        {{ status.split(':')[1] }}
                      </span>
                    </span>
                  </ng-container>
                </td>
              </ng-container>
              <!-- actions -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Actions </th>
                <td mat-cell *matCellDef="let element">
                  <div class="action-buttons">
                    <div class="dropdown">
                      <button
                        class="btn-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="true"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        style="padding-top: 7px;background: transparent;margin: 0;"
                      >
                        <span class="material-symbols-outlined fs-16 cursor_pointer">
                          more_vert
                        </span>
                      </button>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                        style="z-index: 100; top: 56px;"
                      >
                        <li class="cursor-pointer" (click)="openTrainingaction(element, false)">
                          <button class="btn-action" matTooltipClass="primary-tooltip" mat-icon-button>
                            <span class="material-symbols-outlined action-icons">visibility</span>
                          </button>
                          <span class="action-terms">View / Edit</span>
                        </li>
                        <li
                          class="cursor-pointer"
                          (click)="deleteTraining(element.trainingId)"
                        >
                          <button class="btn-action" mat-icon-button>
                            <span class="material-symbols-outlined action-icons">delete</span>
                          </button>
                          <span class="action-terms">Delete</span>
                        </li>
                        <li
                          class="cursor-pointer"
                          (click)="exportEmployeesTraining(element)"
                        >
                          <button class="btn-action" mat-icon-button>
                            <span class="material-symbols-outlined action-icons">move_group</span>
                          </button>
                          <span class="action-terms">Export</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row [class.odd]="i % 2 == 1" [class.even]="i % 2 == 0" *matRowDef="let row; columns: displayedColumns;let i = index;"></tr>
              <!-- Row shown when there is no matching data. -->

            </table>
            <mat-paginator
              [length]="totalRecords"
              [pageSize]="10"
              [pageSizeOptions]="[10,25,50,100]"
              aria-label="Select page"
              (page)="getPaginatorData($event)"
              class="Pagination"
            ></mat-paginator>
            <!-- <div class="pagination">
              <button mat-button class="pagination-button" (click)="onPreviousPage()" [disabled]="currentPage === 1">
                <mat-icon>chevron_left</mat-icon>
              </button>

              <div class="page-numbers">
                <button mat-button class="pagination-button" *ngFor="let page of getPageNumbers()"
                  [class.active]="page === currentPage" (click)="onPageButtonClick(page)" [ngStyle]="{
                        'color': page === currentPage ? 'white' : 'black'
                      }">{{ page }}</button>
              </div>

              <button mat-button class="pagination-button" (click)="onNextPage()"
                [disabled]="currentPage === getTotalPages()">
                <mat-icon> chevron_right </mat-icon>
              </button>
            </div> -->
          </div>
        </ng-container>
      </mat-tab>
      <!-- <mat-tab label="Skills">
        <ng-container *ngIf="selectedTabIndex === 1">
          <app-training-skills></app-training-skills>
        </ng-container>
      </mat-tab> -->
    </mat-tab-group>
  </div>
</div>